/*
 * Analytics — formatting helpers.
 *
 * Per CLAUDE.md: store UTC, render America/New_York in UI. The
 * dashboard is internal staff-only so we use the staff's local zone
 * (US Eastern) — not a buyer's locale.
 */

const NY_TZ = 'America/New_York';

export function fmtMoney(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return '$' + Math.round(n).toLocaleString('en-US');
}

export function fmtMoneyShort(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return '$' + (n / 1_000_000).toFixed(2) + 'M';
  if (Math.abs(n) >= 1_000) return '$' + Math.round(n / 1_000) + 'K';
  return '$' + Math.round(n);
}

export function fmtPct(num: number, denom: number): number {
  return denom > 0 ? Math.round((num / denom) * 100) : 0;
}

export function relTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return '—';
  const dHrs = (Date.now() - t) / 3_600_000;
  if (dHrs < 1) return Math.max(0, Math.round(dHrs * 60)) + 'm ago';
  if (dHrs < 24) return Math.round(dHrs) + 'h ago';
  return Math.round(dHrs / 24) + 'd ago';
}

export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', {
    timeZone: NY_TZ,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    timeZone: NY_TZ,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

const FRICTION_LABELS: Record<string, string> = {
  setup: 'Setup',
  execution: 'Execution',
  handoffs: 'Handoffs',
  closure: 'Closure',
};

const FLEX_LABELS: Record<string, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export function frictionLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return FRICTION_LABELS[key] ?? key;
}

export function flexLabel(key: string | null | undefined): string {
  if (!key) return '—';
  return FLEX_LABELS[key] ?? key;
}
